import { Paper, withStyles } from '@material-ui/core';

export const HighLightedBox = withStyles({
  root: {
    padding: 20,
    marginBlock: 10,
    width: '100%'
  },
})(Paper)